import { createReducer, on, Action } from '@ngrx/store';
import { DataExportActions } from './data-export.actions';

export interface State {
  loading: boolean;
}

export const INITIAL_STATE: State = {
  loading: false,
};

const dataExportReducer = createReducer(
  INITIAL_STATE,
  on(DataExportActions.requestExportCustomersStatisticsForOrganisations, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportMembersStatisticsForOrganisations, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.successSaveFile, (state) => ({ ...state, loading: false }))
);

export function reducer(state: State | undefined, action: Action) {
  return dataExportReducer(state, action);
}
